<div class="flex-col">
  <section class="flex w-full">
    <div class="mt-2 mb-[20px] w-full">
      <div class="flex justify-start text-cafe text-xl sm:text-3xl font-medium font-['Roboto']">
        {{'components.ArtisanDesignerSearchResultComponent.title'| transloco}}
      </div>
    </div>
  </section>
  <!--  all products  -->
  @if(sellers() !== null) {
  @if(sellers()!.length > 0) {
    <section>
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6
        gap-x-0 gap-y-8 md:gap-x-0 md:gap-y-0 lg:gap-y-2 lg:gap-x-2 xl:gap-y-6 xl:gap-x-2
        place-items-start justify-items-center">
        @for(seller of sellers(); track seller.id) {
          <ln-seller-card [seller]="seller"></ln-seller-card>
        }
      </div>
    </section>
  } @else {
    <ln-empty-search-card></ln-empty-search-card>
  }
  }
</div>
